import { FileRepository } from 'ckeditor5/src/upload.js';
import { Command } from 'ckeditor5/src/core.js';
import { toArray } from 'ckeditor5/src/utils.js';
import { insertFileLink } from './utils.js';

/**
 * The upload file command.
 *
 * The command is registered by the {@link fileupload/fileuploadediting~fileUploadEditing} plugin as `uploadFile`
 * and it is also available via aliased `imageUpload` name.
 *
 */
export default class UploadFileCommand extends Command {
    /**
     * @inheritDoc
     */
    refresh() {
        this.isEnabled = true;
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param options Options for the executed command.
     * @param options.file The file or an array of files to upload.
     */
    execute(options) {
        const files = toArray(options.file);
        const model = this.editor.model;
        const selection = model.document.selection;
        // Current text of the link in the document.
        // const linkText = extractTextFromSelection(selection);
        const selectedElement = selection.getSelectedElement();
        const selectionAttributes = Object.fromEntries(selection.getAttributes());

        files.forEach((file, index) => {
            // Inserting of an inline file name replace the selected element and make a selection on the inserted file.
            // Therefore inserting multiple inline files requires creating position after each element.
            if (index && selectedElement) {
                const position = this.editor.model.createPositionAfter(selectedElement);
                this._uploadFile(file, selectionAttributes, position);
            }
            else {
                this._uploadFile(file, selectionAttributes);
            }
        });
    }
    /**
     * Handles uploading single file.
     */
    _uploadFile(file, attributes, position) {
        const editor = this.editor;
        const fileRepository = editor.plugins.get(FileRepository);
        const loader = fileRepository.createLoader(file);
        // Do not throw when upload adapter is not set. FileRepository will log an error anyway.
        if (!loader) {
            return;
        }

        insertFileLink(editor, file, { ...attributes, linkHref: "",  uploadId: loader.id }, position);
    }
}